var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appup-timeago"},[(_vm.moreThenYear || _vm.notValidDatetime)?[_vm._v("\n        "+_vm._s(_vm.datetime)+"\n    ")]:[_c('vue-timeago',{attrs:{"since":_vm.providedDatetime,"auto-update":_vm.autoupdate,"max-update":_vm.maxAutoUpdate}},[_vm._v("\n            "+_vm._s(_vm.providedDatetime)+"\n        ")])]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/timeago/timeago.vue